import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from '../pages/Login/login.js';
import Layout from '../shared/Layout.js';
import ResetPassword from '../pages/Login/resetPassword.js';
import ForgetPassword from '../pages/Login/forgotPassword.js';
import UnAuthorized from '../pages/Login/unAuthorized.js';

const LayoutNavigation = (props) => {
    return (
        <Router>
            <React.Suspense fallback={null}>
                <Routes>
                    <Route exact name="Login" path="/Login" element={<Login authDetails={props.authDetails} />} />
                    {window.location.pathname.toLocaleLowerCase() !== "/login" ?
                        <>
                            <Route name="Layout" path="/" element={<Layout key={'Layout'} componentRoutes={props.componentRoutes} />} >
                                {/* {props.componentRoutes && props?.componentRoutes.map((route, idx) => {
                                    return (
                                        <React.Fragment key={idx}>
                                            {route.component && (
                                                <Route
                                                    key={route.title}
                                                    path={route.path}
                                                    element={<route.component authDetails={route.authDetails} route={Route}  {...props} />} />
                                            )}

                                        </React.Fragment>)
                                })} */}

                                {
                                    (props.authDetails?.roleId && props.authDetails.roleId > 0) ?
                                        <>
                                            {props.componentRoutes && props?.componentRoutes.map((route, idx) => {
                                                return (
                                                    <React.Fragment key={idx}>
                                                        {
                                                            (route.roles.indexOf(props.authDetails.roleId) !== -1 ?
                                                                <>
                                                                    {route.component && (
                                                                        <Route
                                                                            key={route.title}
                                                                            path={route.path}
                                                                            element={<route.component authDetails={route.authDetails} route={Route}  {...props} />} />
                                                                    )}
                                                                </>
                                                                : <>
                                                                    {route.component && (
                                                                        <Route
                                                                            key={idx}
                                                                            path={'authentication/UnAuthorized'}
                                                                            element={<route.component authDetails={route.authDetails} route={Route}  {...props} />} />
                                                                    )
                                                                    }
                                                                </>)
                                                        }
                                                    </React.Fragment>)
                                            })}
                                        </>
                                        :
                                        <>
                                            <Route exact name="Login" path="/Login" element={<Login authDetails={props.authDetails} />} />
                                        </>
                                }
                            </Route>
                        </>
                        :
                        <Route exact name="Login" path="/Login" element={<Login authDetails={props.authDetails} />} />
                    }
                    <Route exact name="ResetPassword" path="/ResetPassword" element={<ResetPassword authDetails={props.authDetails} />} />
                    <Route exact name="ForgetPassword" path="/ForgetPassword" element={<ForgetPassword authDetails={props.authDetails} />} />
                    {(props.authDetails?.roleId && props.authDetails.roleId > 0) ?
                        <Route path='*' exact={true} element={<UnAuthorized authDetails={props.authDetails} />} />
                        : null}
                </Routes>
            </React.Suspense>
        </Router>
    )
}

export default LayoutNavigation;